import AuthLayout from '@/components/layout/AuthLayout.vue';
import VisitorLayout from '@/components/layout/VisitorLayout.vue';
import GetStartedView from '@/views/getStarted/GetStartedView.vue';
import LoginView from '@/views/login/LoginView.vue';
import HomeView from '@/views/home/HomeView.vue';
import ProfileOverviewView from '@/views/profileOverview/ProfileOverviewView.vue';
import ProfileEditView from '@/views/profileEdit/ProfileEditView.vue';
import StoreView from '@/views/store/StoreView.vue';
import NotificationView from '@/views/notification/NotificationView.vue';
import LevelsView from '@/views/levels/LevelsView.vue';
import SelectCategoryGameView from '@/views/game/SelectCategoryGameView.vue';
import LeaderboardView from '@/views/leaderboard/LeaderboardView.vue';
import WinnersPublicView from '@/views/winners/public/WinnersPublicView.vue';
import WinnersAuthView from '@/views/winners/authenticated/WinnersAuthView.vue';
import PrizesView from '@/views/prizes/PrizesView.vue';
import HowItWorksView from '@/views/howItWorks/HowItWorksView.vue';
import MainGameView from '@/views/game/MainGameView.vue';
import BonusGamePuzzleView from '@/views/bonusGame/BonusGamePuzzleView.vue';
import BonusGameLanternView from '@/views/bonusGame/BonusGameLanternView.vue';
import { routeIndexGroupNames } from '@/constants/route.js';
import {
  mainNavigationGuard,
  visitorLayoutNavigationGuard,
  registerNavigationGuard,
  forgotPasswordNavigationGuard,
  storeNavigationGuard,
  leaderboardNavigationGuard,
  winnersNavigationGuard,
  prizesNavigationGuard,
  selectCategoryGameNavigationGuard,
  bonusGameNavigationGuard,
} from '@/router/navigationGuards.js';

export default [
  {
    path: '/',
    beforeEnter: mainNavigationGuard,
    children: [
      {
        path: '',
        component: VisitorLayout,
        beforeEnter: visitorLayoutNavigationGuard,
        children: [
          {
            path: '',
            name: routeIndexGroupNames.VISITOR,
            component: GetStartedView,
          },
          {
            path: 'version',
            name: 'VersionPublic',
            component: () => import('@/views/version/VersionView.vue'),
          },
          {
            path: 'login',
            name: 'Login',
            component: LoginView,
          },
          {
            path: 'register',
            children: [
              {
                path: 'account-verification',
                name: 'RegisterAccountVerification',
                component: () => import('@/views/register/RegisterAccountVerificationView.vue'),
                beforeEnter: registerNavigationGuard,
              },
              {
                path: 'code-verification',
                name: 'RegisterCodeVerification',
                component: () => import('@/views/register/RegisterCodeVerificationView.vue'),
                beforeEnter: registerNavigationGuard,
              },
              {
                path: 'new-password',
                name: 'RegisterNewPassword',
                component: () => import('@/views/register/RegisterNewPasswordView.vue'),
                beforeEnter: registerNavigationGuard,
              },
            ],
          },
          {
            path: 'forgot-password',
            children: [
              {
                path: 'account-verification',
                name: 'ForgotPasswordAccountVerification',
                component: () => import('@/views/forgotPassword/ForgotPasswordAccountVerificationView.vue'),
                beforeEnter: forgotPasswordNavigationGuard,
              },
              {
                path: 'code-verification',
                name: 'ForgotPasswordCodeVerification',
                component: () => import('@/views/forgotPassword/ForgotPasswordCodeVerificationView.vue'),
                beforeEnter: forgotPasswordNavigationGuard,
              },
              {
                path: 'new-password',
                name: 'ForgotPasswordNewPassword',
                component: () => import('@/views/forgotPassword/ForgotPasswordNewPasswordView.vue'),
                beforeEnter: forgotPasswordNavigationGuard,
              },
            ],
          },
          {
            path: 'winners',
            name: 'WinnersPublic',
            component: WinnersPublicView,
            beforeEnter: winnersNavigationGuard,
          },
          {
            path: 'prizes',
            name: 'PrizesPublic',
            component: PrizesView,
            beforeEnter: prizesNavigationGuard,
          },
          {
            path: 'how-it-works',
            name: 'HowItWorksPublic',
            component: HowItWorksView,
          },
        ],
      },
      {
        path: 'home',
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            component: AuthLayout,
            children: [
              {
                path: '',
                name: routeIndexGroupNames.AUTH,
                component: HomeView,
              },
              {
                path: 'version',
                name: 'VersionAuth',
                component: () => import('@/views/version/VersionView.vue'),
              },
              {
                path: 'profile',
                children: [
                  {
                    path: '',
                    name: 'ProfileOverview',
                    component: ProfileOverviewView,
                  },
                  {
                    path: 'edit',
                    name: 'ProfileEdit',
                    component: ProfileEditView,
                  },
                ],
              },
              {
                path: 'forgot-password',
                children: [
                  {
                    path: 'account-verification',
                    name: 'AuthForgotPasswordAccountVerification',
                    component: () => import('@/views/forgotPassword/ForgotPasswordAccountVerificationView.vue'),
                    beforeEnter: forgotPasswordNavigationGuard,
                  },
                  {
                    path: 'code-verification',
                    name: 'AuthForgotPasswordCodeVerification',
                    component: () => import('@/views/forgotPassword/ForgotPasswordCodeVerificationView.vue'),
                    beforeEnter: forgotPasswordNavigationGuard,
                  },
                  {
                    path: 'new-password',
                    name: 'AuthForgotPasswordNewPassword',
                    component: () => import('@/views/forgotPassword/ForgotPasswordNewPasswordView.vue'),
                    beforeEnter: forgotPasswordNavigationGuard,
                  },
                ],
              },
              {
                path: 'store',
                name: 'Store',
                component: StoreView,
                beforeEnter: storeNavigationGuard,
              },
              {
                path: 'notifications',
                name: 'Notifications',
                component: NotificationView,
              },
              {
                path: 'levels',
                name: 'Levels',
                component: LevelsView,
              },
              {
                path: 'leaderboard',
                name: 'Leaderboard',
                component: LeaderboardView,
                beforeEnter: leaderboardNavigationGuard,
              },
              {
                path: 'winners',
                name: 'WinnersAuth',
                component: WinnersAuthView,
                beforeEnter: winnersNavigationGuard,
              },
              {
                path: 'prizes',
                name: 'PrizesAuth',
                component: PrizesView,
                beforeEnter: prizesNavigationGuard,
              },
              {
                path: 'how-it-works',
                name: 'HowItWorksAuth',
                component: HowItWorksView,
              },
            ],
          },
          {
            path: 'select-category',
            name: 'SelectCategoryGame',
            component: SelectCategoryGameView,
            meta: { requiresAuth: true },
            beforeEnter: selectCategoryGameNavigationGuard,
          },
        ],
      },
      {
        path: 'game',
        name: 'MainGame',
        component: MainGameView,
        meta: { requiresAuth: true },
      },
      {
        path: 'bonus-game',
        meta: { requiresAuth: true },
        beforeEnter: bonusGameNavigationGuard,
        children: [
          {
            path: 'puzzle',
            name: 'BonusGamePuzzle',
            component: BonusGamePuzzleView,
          },
          {
            path: 'lantern',
            name: 'BonusGameLantern',
            component: BonusGameLanternView,
          },
        ],
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: routeIndexGroupNames.VISITOR, params: {} },
  },
];
